import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomTooltip from '../../hooks/ToolTip';
import axios from 'axios';
import { useSessionStore } from '../../hooks/useSessionStore';
import { UsuarioContext } from '../../contexts/UsuarioContext';

const validCodes = {
  'PROMO10': 10,
  'BONUS20': 20,
  'GIFT50': 50,
};

const ContentMonedero = () => {
    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
    const [saldo, setSaldo] = useState(0);
    const [promoCode, setPromoCode] = useState('');
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState('');

    useEffect(()=>{
        const fecthSaldo = async () => {
            axios({
                method: 'GET',
                url: window.ipdirection + 'monederoUsuario/',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Usuario.access}`
                }
            }).then((response)=>{
                setSaldo(response.data[0].saldo || 0);
            })
        }
        fecthSaldo()
    },[])

    const canjearCodigo = () => {
        const code = promoCode.trim().toUpperCase();

        axios({
            method: 'PUT',
            url: window.ipdirection + 'monederoUsuario/'+Usuario.cliente.usuario.id+'/',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Usuario.access}`
            },
            data: {
                'codigo': code
            }
        }).then((response) => {
            setSaldo(response.data.saldo);
            setMessage(`¡Código "${code}" canjeado con éxito!`);
            setMessageType('success');

            delete validCodes[code];
        }).catch((error) => {
            setMessage('Código no válido o ya canjeado');
            setMessageType('danger');
        });

        setPromoCode('');
    };

    return (
        <div className='ContentBodyMonitorCuidados'>
            <div className='head-monitorCuidados'>
                <div className='titleMisPacientes'>
                    <div className='tilte centrador'>
                        <i class="bi bi-wallet2"></i>
                        <b>Monedero</b>
                        <CustomTooltip textContent={"Aquí puedes canjear códigos promocionales."}/>
                    </div>
                </div>
                <div className="separador"></div>
            </div>
            <div className="tarjetasPresupuestos-cliente">
                <div className="card shadow-sm border-0 rounded-4 wallet-card-custom">
                    <div className="card-body p-4">
                        <h3 className="mb-5">
                            Saldo actual: <strong className="text-balance-custom">{parseFloat(saldo)}€</strong>
                        </h3>

                        <div className="my-3">
                        <p className="text-muted mb-4 small">
                            Aquí puedes canjear códigos promocionales para añadir dinero a tu cuenta de forma rápida y segura.
                        </p>

                        <label htmlFor="promo" className="form-label fw-semibold">Código promocional</label>
                        <input
                            type="text"
                            id="promo"
                            className="form-control text-dark rounded-3 shadow-sm"
                            value={promoCode}
                            onChange={(e) => setPromoCode(e.target.value)}
                            placeholder="Ingresa tu código"
                        />
                        </div>

                        <button className="btn login-boton" onClick={canjearCodigo}>
                            Canjear código
                        </button>

                        {message && (
                        <div className={`alert mt-3 alert-${messageType} rounded-3`} role="alert">
                            {message}
                        </div>
                        )}
                    </div>
                    </div>
            </div>
        </div>
    );
};

export default ContentMonedero;